<template>
  <v-group
    :config="{
      ...team.canvasConfig.group,
      listening: false,
    }"
  >
    <v-rect :config="team.canvasConfig.rect" />
    <v-text :config="{
      ...team.canvasConfig.text,
      y: -20,
      text: `${team.name} (${team.memberCount}/${team.maxCapacity})`,
      align: 'center',
    }" />
    <v-text :config="{
      x: team.canvasConfig.group.width + 2,
      y: 0,
      text: team.taskPendingCount,
    }" />
    <v-text :config="{
      x: 0,
      y: team.canvasConfig.group.height + 2,
      text: team.taskFinishedCount,
    }" />
  </v-group>
</template>

<script>

export default {
  name: 'PlaygroundTeam',
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
};
</script>
